export default {
    // //根据内核判断浏览器版本
    isPCFn(){
      let sUserAgent = navigator.userAgent.toLowerCase();
      let bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
      let bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
      let bIsMidp = sUserAgent.match(/midp/i) == "midp";
      let bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
      let bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
      let bIsAndroid = sUserAgent.match(/android/i) == "android";
      let bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
      let bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
      let deviceType = ''
      if (bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM) {
        // console.log("您的设备是：phone")
        deviceType = 'phone'
      } else {
        // console.log("您的设备是：pc")
        deviceType = 'pc'
      }
      return deviceType
    },
    browserInfo(){
      var isType = this.isPCFn()
      let browserInfo = null;
      if(isType == 'pc'){
        var navigator = window.navigator;
        var userAgent = navigator.userAgent.toLowerCase();
        // console.log(userAgent);
  
        let isFF = userAgent.indexOf("firefox") > -1; //判断是否Firefox浏览器 ，gecko内核
        let isChrome = userAgent.indexOf("chrome") > -1 && userAgent.indexOf("safari") > -1 //判断Chrome浏览器
        let isIE = /*@cc_on!@*/false || !!document.documentMode;//判断是否是ie内核
        let isEdge = !isIE && !!window.StyleMedia;//判断Edge浏览器
        let isSafari = /constructor/i.test(window.HTMLElement) || (function (p) {
          return p.toString() === "[object //SafariRemoteNotification]";
        })(!window['safari'] || safari.pushNotification);//safari浏览器
  
        var re =/(msie|firefox|chrome|opera|version).*?([\d.]+)/;
        var m = userAgent.match(re) ? userAgent.match(re) : [];
        let version = m[2] ? parseInt(m[2]) : ''
  
        // console.log('火狐',isFF)
        // console.log('Chrome',isChrome)
        // console.log('ie',isIE)
        // console.log('Edge',isEdge)
        // console.log('safari',isSafari)
  
        if(isFF){
          browserInfo = {
            name:'Firefor',
            version:version,
            userAgent:userAgent,
            isHack: version < 21 ? false : true
          }
        }
        if(isChrome){
          browserInfo = {
            name:'chrome',
            version:m[2],
            userAgent:userAgent,
            isHack: version < 21 ? false : true
          }
        }
        if(isIE){
          version = version ? version : 11
          browserInfo = {
            name:'ie',
            version: version,
            userAgent:userAgent,
            isHack: version < 10 ? false : true
          }
        }
        
      }
    //   console.log("浏览器信息",JSON.stringify(browserInfo))
      return browserInfo
    }
  }
  


// WEBPACK FOOTER //
// ./src/commonplugin/BrowserVersion.js